import { render, staticRenderFns } from "./radio-buttons.vue?vue&type=template&id=69e39830"
import script from "./radio-buttons.vue?vue&type=script&lang=ts"
export * from "./radio-buttons.vue?vue&type=script&lang=ts"
import style0 from "./radio-buttons.vue?vue&type=style&index=0&id=69e39830&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports